"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrongCountryException = void 0;
const http_exception_1 = require("../http.exception");
class WrongCountryException extends http_exception_1.HttpException {
    constructor(country) {
        super(501, `Unknown country: ${country}`);
    }
}
exports.WrongCountryException = WrongCountryException;
//# sourceMappingURL=wrongCountry.exception.js.map